// Component Name:  Checkbox component
// Author: Lavanya S
// Platform:
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 26-08-2024
// Description:  This component is designed to handle the checkboxes (custom checkbox)
// props: label, checkedData
// Dependencies: React library,
// Interfaces: props
// Maintenance History: 1.0 First Version

// [22-05-2025] Integrated to CMS
import React, { useEffect, useState } from "react";
import checkedImg from "../../assets/images/auth/LK__Check.svg";
import uncheckedImg from "../../assets/images/auth/LK_white_Uncheck.svg";

/**
 *
 * @param {string} label: string to show the label for the checkbox
 * @param {boolean} checked: boolean value indicationg whether the box is checked or not
 * @param {function} checkedData: callback function to be executed on click.
 *
 * @returns
 */
const CheckBox = ({ label, checkedData, checked }) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    checkedData(!checked); // Pass the new boolean directly
  };

  return (
    <div style={styles.checkboxContainer}>
      <label>
        <img alt={checked ? "checked Img" : "unchecked Img"} src={checked ? checkedImg : uncheckedImg} style={styles.checkImg} onClick={handleToggle} />
      </label>
      <span onClick={handleToggle} style={styles.label}>
        {label}
      </span>
    </div>
  );
};

const styles = {
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  checkImg: {
    width: "15px",
    cursor: "pointer",
  },
  label: {
    cursor: "pointer",
    marginBottom: "4px",
  },
};
export default CheckBox;